/**
 * Content Sections Navigation
 * Handles the navigation between content sections and their display
 * Used for both Projects and Pages with sidebar navigation
 */

(function($) {
    'use strict';

    const ContentSections = {
        init: function() {
            this.setInitialActiveSection();
            this.bindEvents();
            this.handleUrlHash();
        },

        setInitialActiveSection: function() {
            if ($('.project-section').length > 0 && !$('.project-section.active').length) {
                $('.project-section').first().addClass('active');
                $('.project-nav-link').first().addClass('active');
            }
        },

        bindEvents: function() {
            $('.project-nav-link').on('click', this.handleNavClick.bind(this));
        },

        handleNavClick: function(e) {
            e.preventDefault();
            const target = $(e.currentTarget).attr('href');
            
            // Update active classes
            $('.project-nav-link').removeClass('active');
            $(e.currentTarget).addClass('active');
            
            // Show target section
            $('.project-section').removeClass('active');
            $(target).addClass('active');
            
            // Scroll to section on mobile
            if (window.innerWidth < 768) {
                this.scrollToSection(target);
            }
        },

        scrollToSection: function(target) {
            $('html, body').animate({
                scrollTop: $(target).offset().top - 20
            }, 500);
        },

        handleUrlHash: function() {
            if (window.location.hash) {
                const hash = window.location.hash;
                if ($(hash).length) {
                    $('.project-nav-link[href="' + hash + '"]').trigger('click');
                    
                    // Delay scroll to section until page is fully loaded
                    setTimeout(() => {
                        this.scrollToSection(hash);
                    }, 500);
                }
            }
        }
    };

    // Initialize when document is ready
    $(document).ready(function() {
        ContentSections.init();
    });

})(jQuery); 